import { type FC } from "react"

type Props = { title?: string; icon: FC<{ className?: string }>; label: string }
const ProductsBlockPreview: FC<Props> = ({ title, icon: Icon, label }) => {
	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-7xl">
				{title && (
					<h2 className="text-landing-foreground mb-12 text-center text-3xl font-bold tracking-tight sm:text-4xl">
						{title}
					</h2>
				)}
				<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{Array.from({ length: 3 }, (_, i) => (
						<div
							key={i}
							className="border-landing-border bg-landing-surface flex flex-col overflow-hidden rounded-xl border"
						>
							<div className="bg-landing-surface-muted relative aspect-video w-full overflow-hidden">
								<div className="from-landing-surface-muted to-landing-border flex size-full items-center justify-center bg-linear-to-br">
									<Icon className="text-landing-foreground-subtle size-12" />
								</div>
							</div>
							<div className="flex flex-1 flex-col p-5">
								<h3 className="text-landing-foreground text-lg font-semibold tracking-tight">
									{label} {i + 1}
								</h3>
								<p className="text-landing-foreground-muted mt-2 line-clamp-2 flex-1 text-sm leading-6">
									{label} description will appear here
								</p>
								<div className="mt-4 flex items-center justify-end">
									<span className="text-landing-foreground-muted text-sm font-medium">Free</span>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default ProductsBlockPreview
